import { AnchorButton } from "@svea/design-system-components-react";
import { Accordion, Stack, useText } from "@sveabank/cc-common";
import { Link } from "react-router";
import Content from "../../components/content";
import PageNavigationFooter from "../../components/page-navigation-footer";
import Paper from "../../components/paper";
import ReviewSection from "../../components/review-section";
import { withLoader } from "../../hoc/with-loader";
import { usePageContext } from "../../hooks/context";
import { usePages } from "../../hooks/usePages";
import CreditSignFlow from "./credit-sign-flow";
import CustomerAgreementSection from "./customer-agreement-section";
import { useSignInformation } from "./hooks/hooks";
import SigningCompleteSection from "./signing-complete-section";

const SignPage = () => {
	const { isSigningComplete, isOrgEf, hasCreditProduct } = usePageContext(useSignInformation);
	const [t, texts] = useText();
	const { nextPage, prevPage, nextPageAvailable } = usePages();

	return (
		<Content size={12} my={8}>
			<Stack gap={8} component="section">
				<Paper>
					<Accordion>
						<Accordion.Heading>{t(texts.signPage.reviewPage.title)}</Accordion.Heading>
						<Accordion.Content>
							<div className="mt-4">
								<ReviewSection />
							</div>
						</Accordion.Content>
					</Accordion>
				</Paper>

				{hasCreditProduct && !isOrgEf ? <CreditSignFlow /> : <CustomerAgreementSection />}
			</Stack>
			<PageNavigationFooter paddingTop="sign">
				{nextPageAvailable && nextPage && (
					<AnchorButton as={Link} to={nextPage}>
						{t(texts.common.continue)}
					</AnchorButton>
				)}
				{prevPage && (
					<AnchorButton as={Link} variant="secondary" to={prevPage}>
						{t(texts.choosePackage.back)}
					</AnchorButton>
				)}
			</PageNavigationFooter>
			{isSigningComplete && <SigningCompleteSection />}
		</Content>
	);
};

export default withLoader(useSignInformation, SignPage);
